import { createRouter, createWebHistory } from 'vue-router';

const routes = [
  {
    name: 'notFound',
    path: '/:path(.*)+',
    redirect: {
      name: 'index',
    },
  },
  
  {
    name: 'index',
    path: '/index',
    component: () => import('./view/index'),
    meta: {
      title: '會員資訊',
    },
  },
  {
    name: 'error',
    path: '/error',
    component: () => import('./view/error'),
    meta: {
      title: '會員資訊',
    },
  },
  {
    name: 'CustomerInfo',
    path: '/CustomerInfo',
    // query: { uid: '' },
    component: () => import('./view/CustomerInfo/index'),
    meta: {
      title: '會員資訊',
    },
  },
  {
    name: 'Evaluate',
    path: '/Evaluate',
    // query: { uid: '' },
    component: () => import('./view/Evaluate/index'),
    meta: {
      title: '服務評價',
    },
  },
  {
    name: 'HomeIndex',
    path: '/HomeIndex',
    // query: { uid: '' },
    component: () => import('./view/Home/index'),
    meta: {
      title: '服務中心',
    },
  },
  {
    name: 'ServiceRecord',
    path: '/ServiceRecord',
    // query: { uid: '' },
    component: () => import('./view/ServiceRecord/index'),
    meta: {
      title: '服務記錄',
    },
  },
  {
    name: 'ServiceRecordDetail',
    path: '/ServiceRecordDetail',
    // query: { uid: '' },
    component: () => import('./view/ServiceRecord/detail'),
    meta: {
      title: '服務記錄', 
    },
  },
  {
    name: 'Preserve',
    path: '/Preserve',
    // query: { uid: '' },
    component: () => import('./view/ServiceSubmit/preserve'),
    meta: {
      title: '預約保養',
    },
  },
  {
    name: 'Repair',
    path: '/Repair',
    // query: { uid: '' },
    component: () => import('./view/ServiceSubmit/repair'),
    meta: {
      title: '線上報修',
    },
  },
  {
    name: 'UE',
    path: '/UE',
    // query: { uid: '' },
    component: () => import('./view/UE/index'),
    meta: {
      title: '中華機械二手設備',
    },
  },
  {
    name: 'UEdetail',
    path: '/UEdetail',
    // query: { uid: '' },
    component: () => import('./view/UE/detail'),
    meta: {
      title: '設備詳情',
    },
  },
  {
    name: 'UElist',
    path: '/UElist',
    // query: { uid: '' },
    component: () => import('./view/UE/uelist'),
    meta: {
      title: '設備列表',
    },
  },
  {
    name: 'UEimgvideos',
    path: '/UEimgvideos',
    component: () => import('./view/UE/imgvideos'),
    meta: {
      title: '設備相冊',
    },
  },
  {
    name: 'seachlist',
    path: '/seachlist',
    component: () => import('./view/UE/seachlist'),
    meta: {
      title: '設備搜索',
    },
  },
  {
    name: 'choosebrand',
    path: '/choosebrand',
    component: () => import('./view/UE/choosebrand'),
    meta: {
      title: '更多選擇',
    },
  },
  {
    name: 'gg',
    path: '/gg',
    component: () => import('./view/UE/gg'),
    meta: {
      title: '公告',
    },
  },
];

const router = createRouter({
  routes,
  history: createWebHistory(),
});

router.beforeEach((to, from, next) => {
  const title = to.meta && to.meta.title;
  if (title) {
    document.title = title;
  }
  next();
});

export { router };
